import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'receive-data-gyh',
    templateUrl: '../../templates/partials/receiveGYH-bill.html'
})

export class ReceiveGYHBillComponent implements OnInit {

    @Input() receiveData;
    constructor(private router: Router) { }

    public goToCleaner(id: string) {
        this.router.navigate(['/cleaners', id]);
    }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/modules/bills/components/dummy/receiveGYH-bill.component.ts